module.exports = __webpack_public_path__ + "static/media/component10.b668f7bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/component10.png
// module id = 2414
// module chunks = 0